import React from "react";

function NavBar() {
  return (
    <div>
      <header className="App-header">
        <h2>Weather App India</h2>
      </header>
    </div>
  );
}

export default NavBar;
